exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea.ng-invalid.ng-touched, input.ng-invalid.ng-touched {\n    border: 1px solid red;\n}\n\nh3 {\n    margin-bottom: 2rem;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Gabe/Desktop/AngularApps/GabesWebsitePublic/GabesWebsite/src/app/contact-me/contact-me.component.css
// module id = ../../../../../src/app/contact-me/contact-me.component.css
// module chunks = main